<div id="container">
    <div id="back"><img src="../../../../assets/template_icon.png" width="18px" height="21px"/></div>
    <div id="title">{{title}}</div>
    <div id="context"><img src="../../../../assets/sml_context.png"/></div>
</div>